<template>
  <div class="receipt">
    <div class="receipt-wrap" v-if="type == 1">
      <!-- <div class="receipt-img">
        <img :src="info.shopLogo" alt="logo">
      </div>
      <div class="receipt-name">{{info.shopName || '--'}}</div> -->
      <div class="receipt-note">您的取餐号</div>
      <div class="receipt-code">{{info.autoBrandCode || '--'}}</div>
      <!-- <div class="receipt-brand">前面还有<span>18</span>人等待</div> -->
    </div>
    <div class="receipt-save1" v-if="type == 1">
      <el-button type="success" @click="backFn(0)">确认</el-button>
    </div>

    <!-- <div class="receipt-wrap2" v-if="type == 2">
      <div class="receipt-img2">
        <img :src="info.shopLogo" alt="logo">
      </div>
      <div class="receipt-name2">{{info.payAmount || '--'}}</div>
      <div class="receipt-item">
        <div class="receipt-list">
          <h6>订单状态</h6>
          <p>{{info.payAmount || '--'}}</p>
        </div>
        <div class="receipt-list">
          <h6>订单号</h6>
          <p>{{info.orderCode || '--'}}</p>
        </div>
        <div class="receipt-list">
          <h6>支付金额</h6>
          <p>{{info.payAmount || '--'}}</p>
        </div>
      </div>
    </div> -->
    <div class="receipt-wrap3" v-if="type == 2">
      <div class="receipt-img3">
        <img src="../../static/images/pay-f.png" alt="logo">
      </div>
      <!-- <div class="receipt-save3">
        <el-button type="success" @click="backFn(1)">确认</el-button>
      </div> -->
    </div>
  </div>
</template>

<script>
  import {interfaceFn} from '@/assets/util.js'
  export default {
    data () {
      return {
        type: 1,
        info: {},
      }
    },
    created () {
      this.init();
    },
    mounted () {
      // 商家小票
      let mchData = {
        action: 'onIframeReady',
        displayStyle: 'SHOW_CUSTOM_PAGE'
      };
      let postData = JSON.stringify(mchData);
      window.parent.postMessage(postData, 'https://payapp.weixin.qq.com');
    },
    methods: {
      init () {
        var query = this.$route.query || {}; //连接参数
        this.$http.get(interfaceFn() + '/orderMessage/getPayInfo?outTradeNo=' + query.out_trade_no
        + "&subMchId=" + query.sub_mch_id + "&checkCode=" + query.check_code).then(res => {

          if (res.data.returnCode == 'ok') {
            let result = res.data.result;
            this.info = result;
            // result.autoBrandCode = "A123";
            this.type = result.autoBrandCode ? 1 : 2;
          }
        })
      },

      backFn (n) {
        let jumpOutUrl = "";
        if (n === 0) {
          jumpOutUrl = 'http://weixin.ypos.vip/web/?mer=' + this.info.merchantId + '&sho=' + this.info.shopId
          + '&orderCode=' + this.info.orderCode + '&tab=' + this.info.tableId + '&openid=' + this.info.openid;
        } else if (n === 1) {
          jumpOutUrl = 'http://weixin.ypos.vip/web/';
        }
        const mchData = {
          action: "jumpOut",
          jumpOutUrl: jumpOutUrl,
        }; // 跳转到指定的页面并携带参数
        const postData = JSON.stringify(mchData);
        window.parent.postMessage(postData, "*");
      }
    }
  }
</script>

<style scoped>
  .receipt {
    position: relative;
    padding: 20px 0 50px;
    background: #fff;
  }
  .receipt::after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    right: 0;
    height: 10px;
    background: radial-gradient(circle, #fff, #fff 4px, transparent 5px);
    background-size: 10px 10px;
  }
  .receipt-wrap {
    padding: 30px 0;
    position: relative;
    margin: 0 auto;
    width: calc(100% - 80px);
    background: #fff url(../../static/images/bac.png) no-repeat;
    background-size: 100% 100%;
    text-align: center;
  }
  .receipt-img {
    margin: 0 0 0 -26px;
    position: absolute;
    top: -20px;
    left: 50%;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    background: #fff;
    border: 1px solid #fff;
  }
  .receipt-img img {
    width: 100%;
    height: 100%;
  }
  .receipt-name {
    padding: 50px 10px 0;
    line-height: 18px;
    font-weight: bold;
    font-size: 14px;
  }
  .receipt-note {
    padding-top: 20px;
    font-size: 12px;
    color: #ccc;
  }
  .receipt-code {
    padding-bottom: 20px;
    font: bold 40px/80px "微软雅黑";
  }
  .receipt-brand {
    padding-bottom: 30px;
    font-size: 12px;
    color: #5f5f5f;
  }
  .receipt-brand span {
    margin: 0 10px;
    font-weight: bold;
    font-size: 14px;
    color: #333;
  }
  .receipt-save1 {
    margin-top: 30px;
    text-align: center;
  }
  .receipt-save1 button {
    width: calc(100% - 80px);
  }

  .receipt-wrap2 {}
  .receipt-img2 {
    margin: 0 auto;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    background: #fff;
    border: 1px solid #fff;
  }
  .receipt-img2 img {
    width: 100%;
    height: 100%;
  }
  .receipt-name2 {
    padding: 10px;
    text-align: center;
    line-height: 18px;
    font-weight: bold;
    font-size: 14px;
  }
  .receipt-item {
    padding: 0 10px;
  }
  .receipt-list {
    padding: 15px 0;
    display: flex;
    line-height: 18px;
  }
  .receipt-list h6 {
    width: 80px;
    font-size: 14px;
    color: #898989;
  }
  .receipt-list p {
    flex: 1;
    text-align: right;
  }
  .receipt-list:last-of-type {
    border-top: 2px solid #f4f4f5;
  }
  .receipt-wrap3 {
    padding: 50px 0;
    text-align: center;
  }
  .receipt-img3 img {
    width: 100px;
  }
  .receipt-save3 {
    margin-top: 90px;
    text-align: center;
  }
  .receipt-save3 button {
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Receipt.vue